import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Pagamento } from '../models/pagamento';
import { PagamentoService } from '../pagamento.service';

@Component({
  selector: 'app-pagamento-regra',
  templateUrl: './pagamento-regra.component.html',
  styleUrls: ['./pagamento-regra.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class PagamentoRegraComponent implements OnInit {

  constructor(private pagamentoService:PagamentoService) { }

  public pagamentos: Pagamento[];
  public pagamento: Pagamento;
  public idPagamento: number;

  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;

  ngOnInit(): void {
    this.getPagamentos();
  }

  getPagamentos() {
    this.pagamentoService.getPagamentos().subscribe(
      (res) => {
        if (res) {
          this.pagamentos = res;  
          console.log(this.pagamentos);
        }
      },
      err => {
        console.log("Atributos");
        console.log(err);
      }
    );
  } 

  updpagamento(pagamento){

  }
  delpagamento(pagamento){

  }

  hideDialog(){

  }

  savepagamento(){

  }
}
